import { actions } from './nurse_cabinet/actions'
import { getters } from './nurse_cabinet/getters'
import { state } from './nurse_cabinet/state'
import { mutations } from './nurse_cabinet/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
